import React from 'react'
import MenuListItemStyle from './ManuListItemStyle/MenuListItemStyle'

const MenuListItem = ({children}) => (
    <MenuListItemStyle>
        {children}
    </MenuListItemStyle>
)

export default MenuListItem